import { MuiOtpInput } from 'mui-one-time-password-input';
import React, { useEffect, useRef, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { TailSpin } from 'react-loader-spinner';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import config from '../../EnvConfig/env_config';
import BlurLoader from '../CommonComponents/BlurFullPageLoader';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, convertToNumber } from '../CommonComponents/CustomHooks';
import { SetSession } from '../CommonComponents/cryptoUtils';

const Login = () => {
    const inputrefs = useRef([]);
    const canvasRef = useRef(null);
    const StaticToken = config.secret_key;
    const navigate = useNavigate();
    const location = useLocation();
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [Response, setResponse] = useState({});
    const [isValid, setIsValid] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [checkOTPSend, setCheckOTPSend] = useState(false);
    const [timer, setTimer] = useState(0);
    const [isDisabled, setIsDisabled] = useState(false);
    const path = window.location.pathname.split('/')[1];
    const [loginData, setLoginData] = useState({
        userCode: '',
        password: '',
        userType: path ? path : 'Dealer',
        otp: '',
        captcha: '',
        validate: ''
    });

    useEffect(() => {
        let interval;

        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        } else if (timer === 0 && isDisabled) {
            setIsDisabled(false);
        }

        return () => clearInterval(interval);
    }, [timer, isDisabled]);

    const generateCaptchaText = () => {
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
        let text = '';
        for (let i = 0; i < 5; i++) {
            text += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return text;
    };

    const drawCaptcha = (text) => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        // Adjusted background color for better contrast
        ctx.fillStyle = '#f0f0f0';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        const fonts = ['30px Arial'];
        const fontColor = ['000000', '3c6f1e', 'e01313', '417a19', '090b91', '2c3e50', '8e44ad'];
        for (let i = 0; i < text.length; i++) {
            ctx.font = fonts[Math.floor(Math.random() * fonts.length)];
            ctx.fillStyle = '#' + fontColor[Math.floor(Math.random() * fontColor.length)];
            const x = 20 + i * 30 + Math.random() * 10;
            const y = 25 + Math.random() * 10;
            ctx.fillText(text[i], x, y);
        }

        // Random dots (ensure visibility)
        for (let i = 0; i < 50; i++) {
            ctx.fillStyle = '#' + Math.floor(Math.random() * 16777215).toString(16);  // Keeps random but visible
            ctx.beginPath();
            ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, 1, 0, Math.PI * 2);
            ctx.fill();
        }
    };

    const handleLogin = async () => {
        setIsLoading(true);
        const data = {
            ...loginData,
            userCode: loginData.userCode,
            AuthToken: StaticToken,
            Source: 'web'
        };
        if (loginData.userCode === '') {
            NotificationSound('ERROR', `Please enter ${path.toUpperCase().trim() !== 'ADMIN' ? 'Dealer Mobile No.!' : 'User Code.!'}`, 'txtUserCode', inputrefs);
            setIsLoading(false);
            setLoginData({
                ...loginData,
                validate: ''
            });
            return;
        }
        if (path.toUpperCase().trim() === 'ADMIN' && loginData.password === '') {
            NotificationSound('ERROR', 'Please enter Password', 'txtPassword', inputrefs);
            setIsLoading(false);
            setLoginData({
                ...loginData,
                validate: ''
            });
            return;
        }

        if (path.toUpperCase().trim() !== 'ADMIN' && loginData.otp === '') {
            NotificationSound('ERROR', 'Please Send OTP', 'txtotp', inputrefs);
            setIsLoading(false);
            setLoginData({
                ...loginData,
                validate: ''
            });
            return;
        }
        if (loginData.validate === '') {
            NotificationSound('ERROR', 'Captcha validation is required.!');
            inputrefs.current['txtValidate'].focus()
            setIsLoading(false);
            setLoginData({
                ...loginData,
                validate: ''
            });
            return;
        }
        if (loginData.validate !== loginData.captcha) {
            setIsValid(false);
            setIsLoading(false);
            let text = generateCaptchaText()
            drawCaptcha(text);
            setLoginData(prevLoginData => ({ ...prevLoginData, captcha: text, validate: '' }));
            return
        }
        try {
            let res = await ApiCall(`/api/Login/Login`, data);
            setLoginData({ ...loginData, otp: '' })
            if (res.status === 'SUCCESS') {
                SetSession('cookies', 'token', res.loginSessionID);
                SetSession('localStorage', 'theme', 'light');
                SetSession('cookies', 'loginUserType', res.loginUserType);
                SetSession('cookies', 'loginUserCode', res.userCode);
                SetSession('cookies', 'userName', res.userName);
                SetSession('cookies', 'user', res);
                const redirectPath = res.loginUserType === 'Dealer' ? '/Dashboard/DealerDashboard' : '/Dashboard/Dashboard';
                setTimeout(() => {
                    setIsLoading(false);
                    navigate(location.state || redirectPath);
                    localStorage.setItem('ID', "1");
                }, 700);
            } else {
                setIsLoading(false);
                setLoginData({
                    ...loginData,
                    validate: '',
                    otp: ''

                });
                NotificationSound(res.status, res.message, res.focus, inputrefs);
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Login failed', error);
            NotificationSound('ERROR', 'An unexpected error occurred. Please try again later.');

        }
    };

    const handleTogglePassword = (field) => {
        setShowPassword((prevShowPassword) => ({ ...prevShowPassword, [field]: !prevShowPassword[field] }));
    };


    const handleSendOtp = async () => {
        setIsButtonLoading(true);
        try {
            let data = await ApiCall(`/api/Login/SendOTPToMobileNo`, { ...loginData });
            setResponse(data)
            setLoginData(prevData => ({ ...prevData, otp: '', validate: '' }));
            if (data.status === 'SUCCESS') {
                await setTimer(30);
                await setIsDisabled(true);
                await setCheckOTPSend(true);
                setShowOtpInput(true);
            } else if (data.status === 'ERROR') {
                setShowOtpInput(false);
                await NotificationSound(data.status, data.message, data.focus, inputrefs);
            }
        } catch (error) {
            console.error('Error sending OTP:', error);
        } finally {
            setIsButtonLoading(false);
        }
    };
    const handleChangeLogin = (e, file) => {
        if (path.toUpperCase() !== 'ADMIN') {
            file === 'validate' ?
                setLoginData({ ...loginData, [file]: (e.target.value) }) :
                setLoginData({ ...loginData, [file]: convertToNumber(e.target.value) })
        } else {
            setLoginData({ ...loginData, [file]: e.target.value })
        }
    };
    useEffect(() => {
        const text = generateCaptchaText();
        drawCaptcha(text);
        setLoginData(prevLoginData => ({ ...prevLoginData, userType: path ? path : 'Dealer', captcha: text }));
        inputrefs.current['txtUserCode'].focus();
    }, []);

    return (
        <section className='login-page'>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-6 col-md-12 px-0">
                        <div className="login-image">
                            <img src="./images/logo.png" alt="Logo" />
                            <h3>Welcome to <br />CPP Login Panel</h3>
                            <p className="top">Your one stop platform for</p>
                            <p>CPP Membership</p>
                        </div>
                    </div>
                    <div className="col-lg-6 p-0 col-md-12 d-flex justify-content-between flex-column align-items-center">
                        <div className="aboutSec otpSec">
                            <div className="otpSecLft loginLft">
                                <div className='ram'>
                                    <h2 className="logTitle">{path.toUpperCase() === 'ADMIN' ? 'Admin Login Account' : 'Dealer Login Account'}
                                    </h2>
                                    <div className="loginpSec position-relative">
                                        <label htmlFor="txtUserCode" className="form-label lbl">
                                            {path.toUpperCase().trim() === 'ADMIN' ? 'User Code' : 'Mobile No'}
                                        </label>
                                        <div className="" style={{ position: "relative" }}>
                                            <input
                                                className="form-control txtField66 username"
                                                id="txtUserCode"
                                                ref={ref => (inputrefs.current['txtUserCode'] = ref)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        if (path.toUpperCase().trim() === 'ADMIN') {
                                                            inputrefs.current['txtPassword'].focus();
                                                        }
                                                        else {
                                                            inputrefs.current['txtGetOpt'].focus();
                                                        }
                                                    }
                                                }}
                                                placeholder={path.toUpperCase().trim() === 'ADMIN' ? 'User Code' : 'Mobile No'}
                                                maxLength="10"
                                                disabled={isDisabled}
                                                autoComplete="off"
                                                value={loginData.userCode}
                                                onChange={(e) => handleChangeLogin(e, 'userCode')}
                                            />
                                            {path.toUpperCase().trim() !== 'ADMIN' && (
                                                <button
                                                    style={{
                                                        position: "absolute",
                                                        right: "3px",
                                                        top: '24px',
                                                        padding: '2px',
                                                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                    }}
                                                    className="btn btn-primary send-otp-btn"
                                                    onClick={handleSendOtp}
                                                    disabled={isDisabled}
                                                    id="txtGetOpt"
                                                    ref={ref => (inputrefs.current['txtGetOpt'] = ref)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            if (path.toUpperCase().trim() !== 'ADMIN') {
                                                                inputrefs.current['txtotp'].focus();
                                                            }

                                                        }
                                                    }}
                                                >
                                                    {isButtonLoading ? (
                                                        <TailSpin
                                                            height="20"
                                                            width="20"
                                                            color="#fff"
                                                            ariaLabel="loading"
                                                        />
                                                    ) : (
                                                        'Get OTP'
                                                    )}
                                                </button>
                                            )}
                                        </div>

                                        {isDisabled &&
                                            < span className={'text-success'}>{Response.message}</span>
                                        }
                                        {path.toUpperCase().trim() !== 'ADMIN' && (
                                            <>
                                                {showOtpInput && (
                                                    <div className='mt-2 mb-1'>
                                                        <label htmlFor="txtotp" className="form-label">Enter 6 Digit OTP</label>
                                                        <MuiOtpInput
                                                            id="txtotp"
                                                            value={loginData.otp}
                                                            ref={ref => (inputrefs.current['txtotp'] = ref)}
                                                            length={6}
                                                            onChange={(otp) => setLoginData({ ...loginData, otp: convertToNumber(otp) })}
                                                            containerStyle={{ display: 'flex', justifyContent: 'space-between' }}
                                                            inputStyle={{ height: '48px', textAlign: 'center', fontSize: '1rem', borderRadius: '4px' }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    inputrefs.current['txtValidate'].focus()
                                                                };
                                                            }}
                                                        />
                                                        <p className='mt-3 mb-2 d-flex justify-content-center align-items-center'>
                                                            Didn't receive an OTP?
                                                            <button
                                                                type="button"
                                                                onClick={handleSendOtp}
                                                                style={{
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    color: '#007bff',
                                                                    fontWeight: 'bold',
                                                                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                                    marginLeft: '7px',
                                                                    opacity: isDisabled ? 0.5 : 1,
                                                                }}
                                                                disabled={isDisabled}
                                                            >
                                                                {isDisabled ? `Resend (${timer}s)` : 'Resend'}
                                                            </button>
                                                        </p>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>


                                    {path.toUpperCase().trim() === 'ADMIN' && (
                                        <>
                                            <div className="loginpSec position-relative">
                                                <label htmlFor="txtPassword" className="form-label lbl">Password</label>
                                                <input
                                                    id="txtPassword"
                                                    placeholder="Password"
                                                    ref={ref => (inputrefs.current['txtPassword'] = ref)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            inputrefs.current['txtValidate'].focus()
                                                        };
                                                    }}
                                                    maxLength="15"
                                                    type={showPassword.password ? 'text' : 'password'}
                                                    className="form-control txtField pass"
                                                    autoComplete="off"
                                                    value={loginData.password}
                                                    onChange={(e) => handleChangeLogin(e, 'password')}
                                                />
                                                <span style={{ position: "absolute", right: "10px", top: "65%", transform: 'translateY(-58%)', cursor: "pointer" }} onClick={() => handleTogglePassword('password')}>
                                                    {!showPassword.password ? <FaEyeSlash className='eyeIcon' /> : <FaEye className='eyeIcon' />}
                                                </span>
                                            </div>
                                        </>
                                    )}
                                    <div className="my-1 recaptcha-container mt-2 d-md-flex gap-2 align-items-center justify-content-center">
                                        <div className='' >
                                            <canvas ref={canvasRef} width={200} height={40} />
                                        </div>
                                        <i className="fa fa-refresh" style={{ cursor: 'pointer' }}
                                            onClick={
                                                async () => {
                                                    const text = generateCaptchaText()
                                                    await setLoginData(prevLoginData => ({ ...prevLoginData, captcha: text, validate: '' }))
                                                    await drawCaptcha(text);
                                                }}
                                        />
                                        <div className="" >
                                            <input
                                                id="txtValidate"
                                                placeholder="Enter Captcha"
                                                ref={ref => (inputrefs.current['txtValidate'] = ref)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputrefs.current['btnSub'].focus()
                                                    };
                                                }}
                                                maxLength="6"
                                                className="form-control"
                                                autoComplete="off"
                                                value={loginData.validate}
                                                onChange={(e) => {
                                                    handleChangeLogin(e, 'validate')
                                                    setIsValid(true)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    {isValid !== null && (
                                        <div>
                                            {isValid ? '' : <p className='text-danger mb-0'>CAPTCHA is incorrect. Try again.</p>}
                                        </div>
                                    )}
                                    {path === 'Admin' &&
                                        <div className="rmbr-me">
                                            <Link to='/forgotPassword1' className="orSec">Forgot Password</Link>
                                        </div>
                                    }
                                    <button
                                        type="button"
                                        ref={ref => (inputrefs.current['btnSub'] = ref)}
                                        id="btnLogin"
                                        disabled={!checkOTPSend && path.toUpperCase().trim() !== 'ADMIN'}
                                        className={`${checkOTPSend && path.toUpperCase().trim() !== 'ADMIN' ? "pageBtn otpBtn btn-login" : 'btn btn-primary otpBtn pageBtn btn-login'}`}
                                        onClick={handleLogin}
                                    >
                                        Login <i className="fa-solid fa-arrow-right-to-bracket ms-1" />
                                    </button>
                                </div>
                                {isLoading && (<BlurLoader />)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default Login;